import { isEuCountry, getCookiesPolicy } from '@core/analytics'
import type { TBackendApp } from '@core/backend'
import { seedCurrentUser } from '@features/session'
import { cookieConsentStore } from '@features/cookie-consent'

/**
 * Chunks mount by being imported, so boot only has to hand over values the chunk cannot know:
 * audio-web's keys and the backend app blob.
 */
export const seedStoreChunks = (app: TBackendApp['app']) => {
    seedCurrentUser(app.user)

    cookieConsentStore.seedState({
        cookieConsent: getCookiesPolicy(),
        gtmId: app.tagManager.gtmId,
        isEuVisitor: isEuCountry(app.environment.country),
    })
}
